(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[871],{

/***/ 77083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ unete; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components-pages/unete/JoinRemax.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






function JoinRemax() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("join");
  var translationJoinUs = (0,next_intl_cjs_production_min.useTranslations)("join.joinUs");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(BackgroundImage, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Image, {
    src: "/images/image-optimize/multi-agents-join-remax.png",
    alt: "Bienvenido a tu nueva casa Remax Rep\xFAblica Dominicana"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverDetails, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CoverContainer, {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CoverContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CoverTitle, null, translation("title")), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverText, null, translationJoinUs("description")), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverText, null, translationJoinUs("control")), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverText, null, translationJoinUs("remaxBranch")), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "https://reclutamiento.remaxrd.com/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CoverButton, {
    component: "a"
  }, translationJoinUs("joinFamily")))))));
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "eha9ccs8"
} : 0)( true ? {
  name: "n48rgu",
  styles: "width:100%;position:relative"
} : 0);

var BackgroundImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eha9ccs7"
} : 0)( true ? {
  name: "xm351t",
  styles: "width:100%;height:984px;background-color:var(--white);@media screen and (max-width: 991px){height:65vw;}"
} : 0);

var Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "eha9ccs6"
} : 0)( true ? {
  name: "4uwt2b",
  styles: "width:100%;height:100%;object-fit:cover"
} : 0);

var CoverDetails = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eha9ccs5"
} : 0)( true ? {
  name: "bpyois",
  styles: "width:100%;height:100%;position:absolute;top:0;@media screen and (max-width: 991px){position:static;background-color:#1f3565;}"
} : 0);

var CoverContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eha9ccs4"
} : 0)( true ? {
  name: "1st9kbp",
  styles: "height:100%;position:relative"
} : 0);

var CoverContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eha9ccs3"
} : 0)( true ? {
  name: "1e42dlp",
  styles: "position:absolute;left:0;top:190px;width:563px;padding:40px 57px 100px;background-color:#1f3565;@media screen and (max-width: 991px){position:static;width:100%;}@media screen and (max-width: 767px){padding:80px 20px;}"
} : 0);

var CoverTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "eha9ccs2"
} : 0)( true ? {
  name: "2yzo5w",
  styles: "font-size:1.938rem;font-weight:700;color:#fff;margin-bottom:33px;@media screen and (max-width: 480px){font-size:1.638rem;}"
} : 0);

var CoverText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "eha9ccs1"
} : 0)( true ? {
  name: "1a2b0zn",
  styles: "color:#fff;font-size:0.938rem;font-weight:500;margin-bottom:20px;line-height:29px"
} : 0);

var CoverButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "eha9ccs0"
} : 0)( true ? {
  name: "h5ehgb",
  styles: "width:100%;max-width:265px;position:absolute;bottom:-20px;margin:0 auto;left:50%;transform:translateX(-50%);text-decoration:none"
} : 0);

/* harmony default export */ var unete_JoinRemax = (JoinRemax);
// EXTERNAL MODULE: ./custom-hooks/use-width.hook.ts
var use_width_hook = __webpack_require__(44231);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/statistics.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StatisticsStatic;

(function (StatisticsStatic) {
  StatisticsStatic["statistics"] = "/v2/statistics";
})(StatisticsStatic || (StatisticsStatic = {}));

var StatisticsDynamic = {// /**
  //  * @member {string}
  //  * @method GET
  //  * @version 2.0
  //  * @description get Statistics details
  //  */
  // StatisticsDetail: (StatisticsID?: number) =>
  //   `-${StatisticsID}`,
};
var StatisticsEndpoints = _objectSpread(_objectSpread({}, StatisticsDynamic), StatisticsStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/statistics-services.request.ts


var getStatistics = function getStatistics(filters) {
  return (0,base_services_request/* getRequest */.A_)(StatisticsEndpoints.statistics, filters).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
};
;// CONCATENATED MODULE: ./shared/components-pages/unete/Statistic.tsx


function Statistic_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










function Statistic() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("join.statistic");
  var translationStatsLabel = (0,next_intl_cjs_production_min.useTranslations)("join.statistic.statsLabel");
  var translationWhyBeAgent = (0,next_intl_cjs_production_min.useTranslations)("join.statistic.whyBeAgent");
  var statisticDataItems = [{
    title: "1973",
    description: translationStatsLabel("founded")
  }, {
    title: "+300",
    description: translationStatsLabel("agents")
  }, {
    title: "+30",
    description: translationStatsLabel("offices")
  }, {
    title: "+145 ".concat(translationStatsLabel("thousand")),
    description: translationStatsLabel("globalAgents")
  }, {
    title: "+10 ".concat(translationStatsLabel("thousand")),
    description: translationStatsLabel("properties")
  }, {
    title: "15.2 ".concat(translationStatsLabel("years")),
    description: translationStatsLabel("average")
  }];

  var _useState = (0,react.useState)(statisticDataItems),
      items = _useState[0],
      setItems = _useState[1];

  var width = (0,use_width_hook/* useWidth */.z)();

  var fetchStatistics = function fetchStatistics() {
    return getStatistics();
  };

  var _useMutation = (0,useMutation/* useMutation */.D)(["estadisticas"], fetchStatistics, {
    onSuccess: function onSuccess(_ref) {
      var _data$agents_count$to, _data$agencies_count$;

      var data = _ref.data;
      statisticDataItems[1].title = (_data$agents_count$to = data.agents_count.toString()) !== null && _data$agents_count$to !== void 0 ? _data$agents_count$to : 0;
      statisticDataItems[2].title = (_data$agencies_count$ = data.agencies_count.toString()) !== null && _data$agencies_count$ !== void 0 ? _data$agencies_count$ : 0;
      setItems(statisticDataItems);
    }
  }),
      mutate = _useMutation.mutate,
      data = _useMutation.data,
      isLoading = _useMutation.isLoading;

  (0,react.useEffect)(function () {
    mutate();
  }, []);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Statistic_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticContainer, {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticTitle, null, translation.rich("title", {
    red: function red(chunks) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticTitleRed, null, chunks);
    },
    light: function light(chunks) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticTitleLight, null, chunks);
    }
  })), !["xs", "sm"].includes(width) && // <JoinRemaxForm>
  (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "https://reclutamiento.remaxrd.com/",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: 'white'
    }
  }, translation("joinFamily"))) // </JoinRemaxForm>
  , (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticSubContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticSubtitle, null, translationWhyBeAgent("title")), (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticText, null, translationWhyBeAgent("benefits")), (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticText, null, translationWhyBeAgent("info"))), (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticData, null, items.map(function (item, index) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticDataItem, {
      key: index
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticDataTitle, null, item.title), (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticDataDescription, null, item.description));
  })), ["xs", "sm"].includes(width) && // <JoinRemaxForm>
  (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticButton, {
    style: {
      marginTop: 30
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "https://reclutamiento.remaxrd.com/",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: 'white'
    }
  }, translation("joinFamily"))) // </JoinRemaxForm>
  ), (0,emotion_react_browser_esm/* jsx */.tZ)(StatisticBackground, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Statistic_Image, {
    src: "/images/image-optimize/agent-remax-join-franchise.webp",
    alt: "Buscando agente inmobiliario remax RD"
  }))));
}

var sharedCss =  true ? {
  name: "6iu8ll",
  styles: "margin-left:6%;@media screen and (max-width: 767px){margin-left:0;}"
} : 0;

var Statistic_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e4l52ew15"
} : 0)( true ? {
  name: "sfgudk",
  styles: "padding:110px 0 0;margin-bottom:-5px;@media screen and (max-width: 1299px){overflow:hidden;}@media screen and (max-width: 450px){padding:100px 0 0;}"
} : 0);

var StatisticContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4l52ew14"
} : 0)( true ? {
  name: "fhx1m7",
  styles: "display:flex;justify-content:space-between;@media screen and (max-width: 1299px){position:relative;padding-bottom:140px;}"
} : 0);

var StatisticContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e4l52ew13"
} : 0)( true ? {
  name: "17wyc4c",
  styles: "width:calc(100% - 534px);@media screen and (max-width: 1299px){width:calc(100% - 234px);}@media screen and (max-width: 991px){width:100%;}"
} : 0);

var StatisticTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e4l52ew12"
} : 0)(sharedCss, " font-size:3.313rem;font-weight:500;text-align:left;max-width:505px;margin-left:77px;text-transform:none;margin-bottom:26px;line-height:30px;color:var(--color-blue-main);@media screen and (max-width: 767px){font-size:2.313rem;text-align:center;}" + ( true ? "" : 0));

var StatisticTitleRed = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e4l52ew11"
} : 0)( true ? {
  name: "gywozx",
  styles: "font-size:2.188rem;font-weight:700;color:#e92027;display:block;margin-left:19%;@media screen and (max-width: 767px){font-size:1.688rem;text-align:center;margin-left:0;}"
} : 0);

var StatisticTitleLight = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e4l52ew10"
} : 0)( true ? {
  name: "e9jqd9",
  styles: "font-size:1.938rem;font-weight:300;display:block;margin-left:36%;@media screen and (max-width: 767px){font-size:1.438rem;text-align:center;margin-left:0;}"
} : 0);

var StatisticBackground = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4l52ew9"
} : 0)( true ? {
  name: "dpf57l",
  styles: "max-width:634px;align-self:flex-end;@media screen and (max-width: 1299px){position:absolute;right:-15%;bottom:0;}@media screen and (max-width: 1200px){position:absolute;right:-30%;bottom:0;}@media screen and (max-width: 991px){display:none;}"
} : 0);

var Statistic_Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e4l52ew8"
} : 0)( true ? {
  name: "16d60fp",
  styles: "width:100%;border-style:none"
} : 0);

var StatisticButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e4l52ew7"
} : 0)( true ? {
  name: "lytfe6",
  styles: "max-width:265px;margin-left:20%;font-weight:700;text-decoration:none;@media screen and (max-width: 767px){margin-left:auto;margin-right:auto;display:block;}"
} : 0);

var StatisticSubtitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e4l52ew6"
} : 0)(sharedCss, " margin-top:94px;font-size:1.438rem;font-weight:700;margin-bottom:17px;color:var(--color-blue-main);@media screen and (max-width: 450px){margin-top:50px;}" + ( true ? "" : 0));

var StatisticSubContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4l52ew5"
} : 0)( true ? {
  name: "lesovd",
  styles: "width:90%;margin:0 auto"
} : 0);

var StatisticText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e4l52ew4"
} : 0)(sharedCss, " font-size:0.938rem;font-weight:500;color:#99999b;margin-bottom:21px;max-width:625px;" + ( true ? "" : 0));

var StatisticData = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4l52ew3"
} : 0)( true ? {
  name: "1iv732h",
  styles: "margin-top:65px;display:flex;justify-content:space-between;max-width:750px;@media screen and (max-width: 767px){flex-wrap:wrap;justify-content:center;}@media screen and (max-width: 700px){flex-wrap:wrap;justify-content:space-around;}"
} : 0);

var StatisticDataItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4l52ew2"
} : 0)( true ? {
  name: "stj0z5",
  styles: "max-width:113px;@media screen and (max-width: 767px){margin:15px;}@media screen and (max-width: 575px){max-width:140px;}@media screen and (max-width: 450px){width:50%;margin:15px 0;padding:0px;}"
} : 0);

var StatisticDataTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e4l52ew1"
} : 0)( true ? {
  name: "32iyzi",
  styles: "font-size:1.678rem;font-weight:700;color:#5e5e5e;margin-bottom:4px;display:block;white-space:nowrap;text-align:center;@media screen and (max-width: 700px){font-size:35px;}@media screen and (max-width: 575px){max-width:140px;font-size:26px;}@media screen and (max-width: 450px){text-align:left;}"
} : 0);

var StatisticDataDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e4l52ew0"
} : 0)( true ? {
  name: "195cbiw",
  styles: "font-size:0.865rem;font-weight:700;color:#68686a;display:block;text-align:center;@media screen and (max-width: 450px){text-align:left;}"
} : 0);

/* harmony default export */ var unete_Statistic = (Statistic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./shared/components/slide-transition/index.tsx
var slide_transition = __webpack_require__(97472);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(50657);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
;// CONCATENATED MODULE: ./shared/components/video-modal/index.tsx




function video_modal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function video_modal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? video_modal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : video_modal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function video_modal_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function VideoModal(props) {
  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var width = (0,use_width_hook/* useWidth */.z)();
  var opts = {
    height: "380px",
    width: "100%",
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      control: 0
    }
  };

  var handleClickOpen = function handleClickOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var configProp = video_modal_objectSpread({
    open: open,
    TransitionComponent: slide_transition/* default */.Z,
    onClose: handleClose,
    fullWidth: true,
    fullScreen: ["xs", "sm"].includes(width),
    maxWidth: "md"
  }, props);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, /*#__PURE__*/react.cloneElement(props.children, {
    onClick: handleClickOpen,
    id: "FormJoinRemax"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogCustom, configProp, (0,emotion_react_browser_esm/* jsx */.tZ)(DialogHeader, configProp), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogContent/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)(YouTube_esm/* default */.Z, {
    videoId: props.url,
    opts: opts
  }))));
}

var DialogHeader = function DialogHeader(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(DialogTitle/* default */.Z, {
    css: stylesDialogHeader.root,
    fontSize: 12,
    align: "right"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    variant: "text",
    colortext: "--color-gray-02",
    onClick: function onClick() {
      return props.onClose();
    }
  }, "Cerrar"));
};

var TitleForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1yc4ldu1"
} : 0)( true ? {
  name: "l3hp4",
  styles: "color:var(--color-gray-01);font-size:1.2rem;margin-bottom:10px"
} : 0);

var DialogCustom = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Dialog/* default */.Z,  true ? {
  target: "e1yc4ldu0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return {
    "& .MuiDialog-paper": {
      backgroundColor: "#EFEFF1",
      borderRadius: "20px"
    }
  };
},  true ? "" : 0);

var stylesDialogHeader = {
  root:  true ? {
    name: "169ilyi",
    styles: "text-align:right;font-size:13px;color:var(--color-gray-01);cursor:pointer"
  } : 0
};
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
;// CONCATENATED MODULE: ./shared/components-pages/unete/Motivation.tsx


function Motivation_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









function VideosThumbnail(props) {
  var url = props.url,
      videoId = props.videoId,
      thumbnail = props.thumbnail;
  var translation = (0,next_intl_cjs_production_min.useTranslations)("join.motivation");
  var imgSrc;

  if (thumbnail) {
    imgSrc = thumbnail;
  } else {
    imgSrc = "https://img.youtube.com/vi/".concat(videoId, "/maxresdefault.jpg");
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)(VideoModal, {
    url: videoId
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    style: {
      cursor: "pointer"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ThumbnailWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Thumbnail, {
    src: imgSrc
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(VideoText, null, translation("seeVideo"))));
}

var videosItems = [{
  url: "https://www.youtube.com/watch?v=dUSqN6Lb1Wk",
  videoId: "dUSqN6Lb1Wk" // thumbnail: "/images/remaxrd_agent1.png",

} // {
//   url: "https://www.youtube.com/watch?v=U8nRrK1WiwE",
//   videoId: "U8nRrK1WiwE",
//   // thumbnail: "/images/remaxrd_agent2.png",
// },
];

function Motivation() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("join.motivation");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Motivation_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationContainer, {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationVideos, null, videosItems.map(function (item, index) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("article", {
      key: index
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(VideosThumbnail, item));
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationDescription, null, (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationTitle, null, translation("title")), (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationText, null, translation("description")), (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationText, null, translation("info")), (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.frequent_questions */.K.es.frequent_questions,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationButton, {
    disableRipple: true,
    component: "a"
  }, translation("faq"))))));
}

var Motivation_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ewojgm910"
} : 0)( true ? {
  name: "1uy1d3c",
  styles: "background-color:#fff;border-radius:200px 0px 0px 0px;padding:85px 0;@media screen and (max-width: 991px){border-radius:150px 0px 0px 0px;}@media screen and (max-width: 767px){border-radius:50px 0px 0px 0px;}"
} : 0);

var MotivationContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewojgm99"
} : 0)( true ? {
  name: "w27gg",
  styles: "display:flex;justify-content:space-around;@media screen and (max-width: 991px){flex-direction:column;}"
} : 0);

var MotivationDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ewojgm98"
} : 0)( true ? {
  name: "1vxx8qx",
  styles: "max-width:600px;padding:0px 10px;align-self:center"
} : 0);

var MotivationTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "ewojgm97"
} : 0)( true ? {
  name: "10cdqwa",
  styles: "max-width:300px;font-size:1.438rem;font-weight:700;text-align:left;text-transform:none;margin-bottom:24px;color:var(--color-blue-main)"
} : 0);

var MotivationText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "ewojgm96"
} : 0)( true ? {
  name: "pgg5ef",
  styles: "font-size:0.938rem;font-weight:700;line-height:18px;color:#99999b;margin-bottom:20px"
} : 0);

var MotivationButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "ewojgm95"
} : 0)( true ? {
  name: "wv8ltf",
  styles: "margin-top:75px;height:40px;color:var(--white);@media screen and (max-width: 991px){display:block;margin:0 auto;margin-top:75px;}&>a{color:inherit;}&:focus-visible{outline:Highlight auto 1px;outline:-webkit-focus-ring-color auto 1px;}"
} : 0);

var MotivationVideos = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewojgm94"
} : 0)( true ? {
  name: "3pteyl",
  styles: "&>:nth-child(1){margin-bottom:45px;}@media screen and (max-width: 991px){display:flex;justify-content:space-evenly;}@media screen and (max-width: 480px){flex-direction:column;align-items:center;margin-bottom:50px;}"
} : 0);

var VideoLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "ewojgm93"
} : 0)( true ? {
  name: "nxcu0p",
  styles: "text-decoration:\"none\";color:var(--color-blue-main);&:active{text-decoration:inherit;}&:visited{text-decoration:inherit;}"
} : 0);

var Thumbnail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "ewojgm92"
} : 0)( true ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : 0);

var ThumbnailWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewojgm91"
} : 0)( true ? {
  name: "ug3vm9",
  styles: "width:260px;height:170px;border-radius:20px;background-position:center;background-size:cover;background-repeat:no-repeat;margin-bottom:15px;overflow:hidden;@media screen and (max-width: 480px){width:100%;max-width:380px;margin:auto;height:auto;}"
} : 0);

var VideoText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "ewojgm90"
} : 0)( true ? {
  name: "53k9nj",
  styles: "font-size:0.875rem;font-weight:500;text-align:center;color:var(--color-blue-main);cursor:pointer"
} : 0);

/* harmony default export */ var unete_Motivation = (Motivation);
// EXTERNAL MODULE: ./shared/components/head-meta/index.tsx
var head_meta = __webpack_require__(23385);
// EXTERNAL MODULE: ./shared/models/const/keywords.const.ts
var keywords_const = __webpack_require__(6644);
;// CONCATENATED MODULE: ./pages/unete/index.tsx









var Unete = function Unete() {
  var router = (0,next_router.useRouter)();
  var metaData = {
    description: "join",
    keyWords: keywords_const/* CKeyWordsPages.join */.k.join,
    title: "join",
    url: router.asPath,
    picture: "/images/image-optimize/happy-couple-with-keys-of-new-apartment.webp"
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(head_meta/* default */.Z, metaData), (0,emotion_react_browser_esm/* jsx */.tZ)(unete_JoinRemax, null), (0,emotion_react_browser_esm/* jsx */.tZ)(unete_Statistic, null), (0,emotion_react_browser_esm/* jsx */.tZ)(unete_Motivation, null));
};

var __N_SSG = true;
/* harmony default export */ var unete = (Unete);

/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72717);
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);






function HeadMeta(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      og_type = props.og_type,
      picture = props.picture,
      canonical = props.canonical,
      keyWords = props.keyWords;
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("title-pages");
  var MetaDescriptionT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("metaDescriptions");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default()), null, title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", null, titleT(title)), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: description
  }), keyWords && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: keyWords
  }), url && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: "".concat("https://remaxrd.com").concat(url)
  }), og_type && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: og_type
  }), title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: title
  }), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: MetaDescriptionT(description)
  }), picture && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: "https://remaxrd.com" + picture
  }), (url || canonical) && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("".concat("https://remaxrd.com").concat(canonical !== null && canonical !== void 0 ? canonical : url)),
    key: "canonical"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeadMeta);

/***/ }),

/***/ 97472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36864);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);




var SliderTransition = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Transition(props, ref) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    direction: "up",
    ref: ref
  }, props));
});
/* harmony default export */ __webpack_exports__["Z"] = (SliderTransition);

/***/ }),

/***/ 6644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CKeyWordsPages; }
/* harmony export */ });
var CKeyWordsPages = {
  project: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana",
  join: "conviértete en agente inmobiliario remax, únete a remax república dominicana, agente inmobiliario remax, agencia inmobiliaria, agente inmobiliario, agente Remax",
  page404: "pagina no encontrada",
  home: "inmueble, remax rd, remax república dominicana, alquilar una casa, comprar una casa, comercialización de inmuebles, proyectos en construcción, beneficios de comprar en planos, préstamos hipotecarios, préstamos hipotecarios en república dominicana, franquicia remax, Propiedades destacadas, propiedades de Remax RD, propiedades de remax república dominicana, agente inmobliario, agencia inmobiliaria, propiedades en República Dominicana, alquiler apartamento, bienes raices santo domingo, departamentos en alquiler santo domingo, proyectos de apartamentos en punta cana, alquilar casa, apartamentos en santo domingo este, apartamentos en bavaro, apartamento en venta punta cana, apartamentos en rd, apartamentos en alquiler santo domingo este, proyectos de apartamentos económicos en santo domingo, apartamentos en venta san isidro, apartamentos en venta republica dominicana, apartamentos en alquiler en santo domingo distrito nacional, apartamento en alquiler, casas en alquiler en república dominicana, proyectos de apartamentos en santo domingo distrito nacional, venta de propiedades en republica dominicana, casas rd, venta de casas en santo domingo, apartamento en el millon, alquiler de apartamentos en santo domingo distrito nacional, comprar apartamento en santo domingo, compra de apartamentos en santo domingo, apartamentos en la romana",
  homeCollections: "Remax collection, propiedades de lujo, propiedades exclusivas, propiedades premium, propiedades collection",
  mortgageLoad: "préstamo hipotecario, Calculadora de prestamos, cuota de préstamos hipotecarios, formulario de prestamos",
  iWantToRent: "casas en alquiler, villas en alquiler, townhouse en alquiler, apartamento en alquiler, oficinas en alquiler, almacén en alquiler, villas en alquiler, alquiler de aparta estudio, proyectos exclusivos de remax república dominicana",
  iWantToBuy: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana, compra inmobiliaria, adquir propiedad inmobiliaria, inversion inmobiliaria en república dominicana, inversión inmobiliaria"
};

/***/ }),

/***/ 51092:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unete",
      function () {
        return __webpack_require__(77083);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3913,9774,2888,179], function() { return __webpack_exec__(51092); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);